import React from "react";
import { Button, Icon, Toast } from "antd-mobile";

import "./index.less";

class AgreementText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="AgreementTextBox">
                <div>
                    <h1>《远程慧联如何保护您的信息》</h1>
                    <div>
                        您提交个人身份等信息（以下简称“个人信息”）时已经充分知悉并同意:
                    </div>
                    <p>
                        (1）为了完成本项目的有关业务，您已经授权您的企业自行或者委托远程慧联将您的个人信息提交给有关主体；
                    </p>
                    <p>
                        (2）除了前述（1）外，远程慧联不会主动将您的个人信息提交给任何第三人；
                    </p>
                    <Button
                        type="primary"
                        onClick={() => {
                            this.props.onQuit(false);
                        }}
                    >
                        确认
                    </Button>
                </div>
            </div>
        );
    }
}

export default AgreementText;



// WEBPACK FOOTER //
// ./src/authCertificate/modules/agreementText/index.js